/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoveAppointmentRequest
 */
export interface MoveAppointmentRequest {
    /**
     * 
     * @type {Date}
     * @memberof MoveAppointmentRequest
     */
    newStartTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof MoveAppointmentRequest
     */
    newEndTimeUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof MoveAppointmentRequest
     */
    reason: string | null;
}

/**
 * Check if a given object implements the MoveAppointmentRequest interface.
 */
export function instanceOfMoveAppointmentRequest(value: object): value is MoveAppointmentRequest {
    if (!('newStartTimeUtc' in value) || value['newStartTimeUtc'] === undefined) return false;
    if (!('newEndTimeUtc' in value) || value['newEndTimeUtc'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function MoveAppointmentRequestFromJSON(json: any): MoveAppointmentRequest {
    return MoveAppointmentRequestFromJSONTyped(json, false);
}

export function MoveAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoveAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newStartTimeUtc': (new Date(json['newStartTimeUtc'])),
        'newEndTimeUtc': (new Date(json['newEndTimeUtc'])),
        'reason': json['reason'],
    };
}

export function MoveAppointmentRequestToJSON(json: any): MoveAppointmentRequest {
    return MoveAppointmentRequestToJSONTyped(json, false);
}

export function MoveAppointmentRequestToJSONTyped(value?: MoveAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newStartTimeUtc': value['newStartTimeUtc'].toISOString(),
        'newEndTimeUtc': value['newEndTimeUtc'].toISOString(),
        'reason': value['reason'],
    };
}

